// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "button-VUKvd";
var _4 = "button_small-1Q_Z1";
var _5 = "primary-20kTc";
var _6 = "secondary-3WMiQ";
var _7 = "counter_button-1Wq6t";
var _8 = "button_disabled-cMK85";
var _9 = "link_button-aS5em";
var _a = "action-1IZmy";
var _b = "w100-DDoto";
var _c = "action__colorsOnly-23pVo";
var _d = "mobile_radius0-1gRbs";
export { _1 as "__esModule", _2 as "mobile", _3 as "button", _4 as "button_small", _5 as "primary", _6 as "secondary", _7 as "counter_button", _8 as "button_disabled", _9 as "link_button", _a as "action", _b as "w100", _c as "action__colorsOnly", _d as "mobile_radius0" }
export default { "__esModule": _1, "mobile": _2, "button": _3, "button_small": _4, "primary": _5, "secondary": _6, "counter_button": _7, "button_disabled": _8, "link_button": _9, "action": _a, "w100": _b, "action__colorsOnly": _c, "mobile_radius0": _d }
